import scopes from '@/apis/coreIAM/scopes'
import { scopesTypes } from '@/store/mutationTypes'

export default {
    state: {
        fetchAllCurrentRoles: {
            pending: false,
            error: null,
        },
        fetchAllAvailableRoles: {
            pending: false,
            error: null,
        },
        addRoleToScope: {
            pending: false,
            error: null,
        },
        removeRoleFromScope: {
            pending: false,
            error: null,
        }
    },
    mutations: {
        [scopesTypes.FETCH_ALL_CURRENT_ROLES_REQUEST]: function (state) {
            state.fetchAllCurrentRoles.pending = true;
        },
        [scopesTypes.FETCH_ALL_CURRENT_ROLES_SUCCESS]: function (state) {
            state.fetchAllCurrentRoles.error = null;
            state.fetchAllCurrentRoles.pending = false;
        },
        [scopesTypes.FETCH_ALL_CURRENT_ROLES_FAILURE]: function (state, error) {
            state.fetchAllCurrentRoles.error = error;
            state.fetchAllCurrentRoles.pending = false;
        },
        [scopesTypes.FETCH_ALL_AVAILABLE_ROLES_REQUEST]: function (state) {
            state.fetchAllAvailableRoles.pending = true;
        },
        [scopesTypes.FETCH_ALL_AVAILABLE_ROLES_SUCCESS]: function (state) {
            state.fetchAllAvailableRoles.error = null;
            state.fetchAllAvailableRoles.pending = false;
        },
        [scopesTypes.FETCH_ALL_AVAILABLE_ROLES_FAILURE]: function (state, error) {
            state.fetchAllAvailableRoles.error = error;
            state.fetchAllAvailableRoles.pending = false;
        },
        [scopesTypes.ADD_ROLE_TO_SCOPE_REQUEST]: function (state) {
            state.addRoleToScope.pending = true;
        },
        [scopesTypes.ADD_ROLE_TO_SCOPE_SUCCESS]: function (state) {
            state.addRoleToScope.error = null;
            state.addRoleToScope.pending = false;
        },
        [scopesTypes.ADD_ROLE_TO_SCOPE_FAILURE]: function (state, error) {
            state.addRoleToScope.error = error;
            state.addRoleToScope.pending = false;
        },
        [scopesTypes.REMOVE_ROLE_FROM_SCOPE_REQUEST]: function (state) {
            state.removeRoleFromScope.pending = true;
        },
        [scopesTypes.REMOVE_ROLE_FROM_SCOPE_SUCCESS]: function (state) {
            state.removeRoleFromScope.error = null;
            state.removeRoleFromScope.pending = false;
        },
        [scopesTypes.REMOVE_ROLE_FROM_SCOPE_FAILURE]: function (state, error) {
            state.removeRoleFromScope.error = error;
            state.removeRoleFromScope.pending = false;
        },
    },
    actions: {
        async fetchAllCurrentRoles({ commit }, payload) {
            commit(scopesTypes.FETCH_ALL_CURRENT_ROLES_REQUEST)
            return new Promise((resolve, reject) => {
                scopes
                    .getCurrentRoles(payload.scopeUuid)
                    .then((roles) => {
                        commit(scopesTypes.FETCH_ALL_CURRENT_ROLES_SUCCESS)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(scopesTypes.FETCH_ALL_CURRENT_ROLES_FAILURE)
                        reject(error)
                    })
            })
        },
        async fetchAllAvailableRoles({ commit }, payload) {
            commit(scopesTypes.FETCH_ALL_AVAILABLE_ROLES_REQUEST)
            return new Promise((resolve, reject) => {
                scopes
                    .getAvailableRoles(payload.scopeUuid)
                    .then((roles) => {
                        commit(scopesTypes.FETCH_ALL_AVAILABLE_ROLES_SUCCESS)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(scopesTypes.FETCH_ALL_AVAILABLE_ROLES_FAILURE)
                        reject(error)
                    })
            })
        },
        async addRoleToScope({ commit }, payload) {
            commit(scopesTypes.ADD_ROLE_TO_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                scopes
                    .addRoleToScope(payload.scopeUuid, payload.roleUuid, payload.roleName)
                    .then((roles) => {
                        commit(scopesTypes.ADD_ROLE_TO_SCOPE_SUCCESS)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(scopesTypes.ADD_ROLE_TO_SCOPE_FAILURE)
                        reject(error)
                    })
            })
        },
        async removeRoleFromScope({ commit }, payload) {
            commit(scopesTypes.REMOVE_ROLE_FROM_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                scopes
                    .removeRoleFromScope(payload.scopeUuid, payload.roleUuid, payload.roleName)
                    .then((roles) => {
                        commit(scopesTypes.REMOVE_ROLE_FROM_SCOPE_SUCCESS)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(scopesTypes.REMOVE_ROLE_FROM_SCOPE_FAILURE)
                        reject(error)
                    })
            })
        },
    }
}